module.exports = __webpack_public_path__ + "static/img/title_4.d609c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/title_4.png
// module id = nVZA
// module chunks = 1